import * as React from "react";
const SvgFiRrFirstMedal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22.21.939A1.98 1.98 0 0 0 20.52 0h-3.008a3.97 3.97 0 0 0-3.587 2.23l-1.861 3.773q-.031-.002-.062-.003l-.041.002L10.1 2.23A3.98 3.98 0 0 0 6.513 0h-3.01C2.813 0 2.18.351 1.816.938A1.98 1.98 0 0 0 1.72 2.87l3.232 6.552A8.95 8.95 0 0 0 3.002 15c0 4.963 4.038 9 9 9s9-4.037 9-9a8.95 8.95 0 0 0-1.937-5.56l3.242-6.57a1.98 1.98 0 0 0-.095-1.931zM6.51 2c.768 0 1.455.428 1.794 1.115l1.555 3.153a9 9 0 0 0-3.416 1.666L3.502 2zM12 22c-3.86 0-7-3.141-7-7 0-3.66 2.825-6.668 6.408-6.97h.005c.194-.016.389-.03.587-.03 3.86 0 7 3.141 7 7s-3.14 7-7 7m5.57-14.055a9 9 0 0 0-3.411-1.672l1.558-3.158A1.99 1.99 0 0 1 17.51 2l3-.015-2.94 5.959zM13 11.946v7.055a1 1 0 1 1-2 0v-5.713l-.293.293a.999.999 0 1 1-1.414-1.414l1.242-1.242a1.44 1.44 0 0 1 1.574-.312c.542.225.89.747.89 1.333"
    />
  </svg>
);
export default SvgFiRrFirstMedal;
